import { theme as baseTheme } from '@chilecompra/react-kit/styles'
import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    custom: {
      bigStone: '#152935',
      blue: {
        95.5: '#E6F0FF80',
        50.15: '#0064FF26',
        50.1: '#0064FF1A'
      },
      gray: {
        95.5: '#F3F5F780',
        75.5: '#B3BECB80',
        50.1: '#768AA21A',
        20.2: '#2E384D33',
        20.15: '#2E384D26'
      },
      red: {
        50.07: '#E22C2C12'
      },
      midnight: '#001C41', // Footer chilecompra
      persianBlue: '#2244BF',
      shuttleGray: '#5A6872'
    },
    charts: {
      ruby: '#D81B60',
      cyan: '#00ACC1'
    }
  }
})

export default theme
